import AdminDownloadAssetRequestModelBase from '../_generated/modelBases/admin-download-asset-request-model-base';

export default class AdminDownloadAssetRequestModel extends AdminDownloadAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
